<template>
  <div class="d-flex w-100">
    <b-container fluid class="p-0 bg-transparent">
      <b-row no-gutters>
        <b-col cols="8" class="pr-3">
          <v-autocomplete
            outlined
            class="poppins"
            multiple
            :items="availableItems"
            v-model="rule.filterData"
            :label="$t(filter.name)"
            item-text="text"
            item-value="index"
            dense
            messages=""
            clearable
            small-chips
            deletable-chips
            :error-messages="filterDataErrors"
            @blur="$v.rule.filterData.$touch()"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @mousedown.prevent @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="
                      rule?.filterData?.length > 0 ? 'purple darken-2' : ''
                    "
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Select All </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
        </b-col>
        <b-col cols="4" class="pr-3">
          <v-text-field
            v-model.number="rule.threshold"
            type="number"
            :min="1"
            :label="$t('threshold')"
            dense
            outlined
            :error-messages="thresholdErrors"
            @blur="$v.rule.threshold.$touch()"
          />
        </b-col>
      </b-row>
    </b-container>
    <div class="max-h-65">
      <button
        class="h-40px w-40px btn btn-sm btn-icon btn-light-info btn-hover-light"
        @click="deleteRule"
      >
        <span class="svg-icon">
          <v-icon size="18">mdi-delete</v-icon>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { SET_FILTERS_DATA } from "@/core/services/store/filter.module";

export default {
  name: "Action",
  mixins: [validationMixin],
  validations: {
    rule: {
      filterData: { required },
      threshold: { required },
    },
  },
  props: {
    rule: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
    },
    availableItems: {
      type: Array,
      default: () => [],
    },
    updateValues: {
      required: true,
      type: Function,
    },
    index: {
      required: true,
      type: Number,
    },
    selectedReportNotificationType: {
      type: String,
      required: true,
    },
  },
  // data: () => ({ filterData: [], threshold: null }),
  computed: {
    filterAllData() {
      return this.$store.getters.getFiltersData;
    },
    selectedAll() {
      return (
        this.rule?.filterData?.length > 0 &&
        this.rule?.filterData.length === this.availableItems.length
      );
    },
    selectedSome() {
      return this.rule?.filterData?.length > 0 && !this.selectedAll;
    },
    icon() {
      if (this.selectedAll) return "mdi-close-box";
      if (this.selectedSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    thresholdErrors: function () {
      return this.handleFormValidation("threshold", this, "rule");
    },
    filterDataErrors: function () {
      return this.handleFormValidation("filterData", this, "rule");
    },
  },
  methods: {
    resetFilterData() {
      this.rule.filterData = [];
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.rule.filterData = [];
        } else {
          this.rule.filterData = this.availableItems.map(
            (value) => value.index
          );
        }
      });
    },

    handleFormValidation(fieldName, vueObj, dataName) {
      const errors = [];
      if (!vueObj.$v[dataName][fieldName].$dirty) return errors;
      if ("required" in vueObj.$v[dataName][fieldName]) {
        !vueObj.$v[dataName][fieldName].required &&
          errors.push(this.$t("this_field_is_required"));
      }
      if ("numeric" in vueObj.$v[dataName][fieldName]) {
        !vueObj.$v[dataName][fieldName].numeric &&
          errors.push(this.$t("this_must_be_number"));
      }
      return errors;
    },
    deleteRule: function () {
      const self = this;
      const parentRules = self.$parent.currentQuery;
      parentRules.splice(parentRules.indexOf(self.rule), 1);
      this.$nextTick(() => {
        this.updateValues();
      });
    },
  },
  watch: {
    rule: {
      handler() {
        const all = { ...this.filterAllData };

        const data = {
          value: this.rule.filterData,
          threshold: this.rule.threshold,
        };
        const type = this.selectedReportNotificationType;

        if (!all[type]) {
          all[type] = [];
        }

        all[type][this.index] = data;
        all[`${this.selectedReportNotificationType}`][this.index] = data;
        this.$store.commit(SET_FILTERS_DATA, all);
      },
      deep: true,
    },
  },
};
</script>
